import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { TradingPartnerType } from '../enums.ts';
import api from '../api/index.ts';
import { Toast } from '../types/models.ts';
import endpoints from '../endpoints.ts';
import { TRADING_PARTNER_QUERY_KEY } from '../queryHooks/tradingPartnerQueryHooks.ts';

const useUpdateOne = (
  options?: UseMutationOptions<
    Toast | null,
    unknown,
    {
      id: number | string;
      name: string;
      type: TradingPartnerType;
      isActive: boolean;
    }
  >
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [endpoints.tradingPartner.update.one.tradingPartner()],
    mutationFn: api.tradingPartner.update.one.tradingPartner,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [TRADING_PARTNER_QUERY_KEY],
      });
    },
    ...options,
  });
};

const tradingPartnerMutationHooks = {
  useUpdateOne
}

export default tradingPartnerMutationHooks;